<p-dialog
  [modal]="true"
  [(visible)]="dialogVisible"
  (onHide)="onDialogHide()"
  [style]="{
    width: '92vw',
    height: '92vh',
    display: 'flex',
    'flex-direction': 'column',
  }"
  [contentStyle]="{
    display: 'flex',
    'flex-direction': 'column',
    flex: '1 1 auto',
    'min-height': '0',
    overflow: 'hidden',
    'padding-top': '0',
  }"
  [appendTo]="'body'"
  [dismissableMask]="true"
  [closable]="true"
  [blockScroll]="false"
>
  <ng-template #header>
    <div class="flex items-center gap-3 overflow-x-auto pr-2">
      @for (step of steps(); track step.number; let i = $index) {
        <div class="flex items-center gap-2 shrink-0">
          <div
            class="w-7 h-7 flex items-center justify-center text-sm font-semibold"
            [class.bg-primary-100]="
              isStepActive(step.number) || isStepCompleted(step.number)
            "
            [class.bg-surface-switch-200]="
              !isStepActive(step.number) && !isStepCompleted(step.number)
            "
            [class.text-primary]="
              isStepActive(step.number) || isStepCompleted(step.number)
            "
            [class.text-surface-switch-700]="
              !isStepActive(step.number) && !isStepCompleted(step.number)
            "
          >
            @if (isStepCompleted(step.number)) {
              <i class="pi pi-check"></i>
            } @else {
              {{ step.number }}
            }
          </div>
          <span
            class="text-md font-medium"
            [class.text-primary]="
              isStepActive(step.number) || isStepCompleted(step.number)
            "
            [class.text-muted-color]="
              !isStepActive(step.number) && !isStepCompleted(step.number)
            "
          >
            {{ step.label }}
          </span>
          @if (i < steps().length - 1) {
            <i class="pi pi-angle-right text-muted-color text-xs ml-1"></i>
          }
        </div>
      }
    </div>
  </ng-template>

  <div class="flex flex-col flex-1 min-h-0">
    @if (currentStep() === 1) {
      @if (phase() === "select") {
        <div class="flex-1 min-h-0 flex flex-col">
          <p-tabs
            class="flex-1 min-h-0 flex flex-col"
            [value]="activeSelectionTab"
            (valueChange)="activeSelectionTab = $any($event)"
          >
            <p-tablist>
              <p-tab value="upload">Upload New Drawing</p-tab>
              <p-tab value="existing">Use Existing Drawing</p-tab>
            </p-tablist>
            <p-tabpanels class="flex-1 min-h-0">
              <p-tabpanel value="upload" class="h-full min-h-0">
                <app-upload-cad
                  [multiple]="true"
                  [accept]="drawingUploadAccept"
                  [extensionsLabel]="drawingUploadExtensionsLabel"
                  (filesSelected)="onFilesSelected($event)"
                />
              </p-tabpanel>
              <p-tabpanel value="existing" class="h-full min-h-0">
                <app-use-existing-drawing
                  [excludedIds]="excludedDrawingIds"
                  [currentQuoteId]="quoteService.quote.id"
                  [currentRevisionNumber]="quoteService.revision.number"
                  (filesSelected)="onExistingDrawingsSelected($event)"
                />
              </p-tabpanel>
            </p-tabpanels>
          </p-tabs>
        </div>

        @if (fileTypeError()) {
          <p-message severity="error" styleClass="w-full mt-4">
            {{ fileTypeError() }}
          </p-message>
        }
      } @else {
        <div class="flex flex-col items-center justify-center flex-1 px-8">
          @if (phase() === "uploading" || phase() === "processing") {
            @if (phase() === "uploading") {
              <p class="text-muted-color mt-4 flex items-center gap-2 mb-2">
                <p-progress-spinner
                  aria-label="Uploading"
                  strokeWidth="10"
                  class="inline-block shrink-0"
                  style="
                    width: 1em;
                    height: 1em;
                    --p-progressspinner-color-one: var(--p-primary-color);
                    --p-progressspinner-color-two: var(--p-primary-color);
                    --p-progressspinner-color-three: var(--p-primary-color);
                    --p-progressspinner-color-four: var(--p-primary-color);
                  "
                />
                Uploading
              </p>
              <p-progressbar class="w-full" [mode]="'indeterminate'" />
            }

            @if (phase() === "processing") {
              <p class="text-muted-color mt-4 flex items-center gap-2 mb-2">
                <p-progress-spinner
                  aria-label="Processing extraction"
                  strokeWidth="10"
                  class="inline-block shrink-0"
                  style="
                    width: 1em;
                    height: 1em;
                    --p-progressspinner-color-one: var(--p-primary-color);
                    --p-progressspinner-color-two: var(--p-primary-color);
                    --p-progressspinner-color-three: var(--p-primary-color);
                    --p-progressspinner-color-four: var(--p-primary-color);
                  "
                />
                Processing extraction
              </p>
              <p-progressbar class="w-full" [mode]="'indeterminate'" />
            }

            @if (activeProcessingFilename(); as filename) {
              <p class="text-muted-color text-sm mt-2 text-center">
                {{ filename }}
              </p>
            }
          }

          @if (phase() === "failed") {
            <p-message severity="error" styleClass="w-full">
              {{
                processingError() ||
                  uploadError() ||
                  "Drawing upload or extraction failed."
              }}
            </p-message>
            <p-button
              class="mt-4"
              label="Upload another PDF"
              severity="secondary"
              (onClick)="resetToUpload()"
            />
          }
        </div>
      }
    } @else {
      <div class="flex-1 min-h-0 overflow-y-auto">
        <div class="flex flex-col gap-3">
          <div class="min-w-0">
            <h3 class="text-lg font-semibold m-0">Review Drawing Details</h3>
            <p class="text-sm text-muted-color mt-1 mb-0 truncate">
              {{ sourceHeader() }}
            </p>
          </div>

          @if (drawingFiles().length > 1) {
            <p-tabs
              [value]="activeDrawingId() ?? drawingFiles()[0].id"
              (valueChange)="onActiveTabChange($any($event))"
            >
              <p-tablist>
                @for (drawing of drawingFiles(); track drawing.id) {
                  <p-tab [value]="drawing.id">
                    <span class="inline-flex items-center gap-2">
                      {{ tabLabel(drawing) }}
                      @if (tabNeedsReview(drawing)) {
                        <span
                          class="inline-block w-2 h-2 rounded-full bg-orange-400"
                          aria-label="Needs review"
                        ></span>
                      }
                    </span>
                  </p-tab>
                }
              </p-tablist>
            </p-tabs>

            @if (needsReviewSummary()) {
              <p class="text-sm text-orange-400 m-0 flex items-center gap-2">
                <span
                  class="inline-block w-2 h-2 rounded-full bg-orange-400"
                ></span>
                {{ needsReviewSummary() }}
              </p>
            }
          }

          @if (hasSuggestions()) {
            <div
              class="grid grid-cols-1 gap-4 rounded-lg border border-surface-switch-200 bg-surface-switch-50 p-4 xl:grid-cols-2"
            >
              <div class="min-w-0 flex flex-col gap-3">
                <div class="flex items-center gap-2 text-sm font-medium">
                  <i class="pi pi-sparkles text-primary" aria-hidden="true"></i>
                  Part overview
                </div>
                @if (suggestions()?.overview?.trim()) {
                  <p class="m-0 text-sm leading-relaxed">
                    {{ suggestions()?.overview }}
                  </p>
                }
                @if (suggestions()?.blueprint; as blueprint) {
                  <div class="flex flex-wrap items-center gap-2 text-sm">
                    <i
                      class="pi pi-box text-muted-color"
                      aria-hidden="true"
                    ></i>
                    <span>Suggested blueprint · {{ blueprint.name }}</span>
                    @if (blueprint.reason.trim()) {
                      <button
                        type="button"
                        class="pi pi-info-circle text-sm text-muted-color cursor-pointer bg-transparent border-0 p-0 leading-none"
                        [pTooltip]="blueprint.reason"
                        tooltipPosition="top"
                        tooltipEvent="both"
                        [attr.aria-label]="
                          'Suggested blueprint reasoning: ' + blueprint.reason
                        "
                      ></button>
                    }
                    <span class="font-medium text-green-500">
                      {{ matchLabel(blueprint.confidence) }}
                    </span>
                  </div>
                }
                @if (alternateBlueprintLabel()) {
                  <p class="m-0 text-sm text-muted-color">
                    Also close: {{ alternateBlueprintLabel() }}
                  </p>
                }

                @if (hasCustomTree()) {
                  <div class="flex flex-col gap-2">
                    <div
                      class="flex flex-wrap items-center gap-2 text-sm font-medium"
                    >
                      <i
                        class="pi pi-sitemap text-muted-color"
                        aria-hidden="true"
                      ></i>
                      <span>AI-suggested draft structure</span>
                      @if (customTree()?.reason?.trim(); as treeReason) {
                        <button
                          type="button"
                          class="pi pi-info-circle text-sm text-muted-color cursor-pointer font-normal bg-transparent border-0 p-0 leading-none"
                          [pTooltip]="treeReason"
                          tooltipPosition="top"
                          tooltipEvent="both"
                          [attr.aria-label]="
                            'Suggested draft structure reasoning: ' + treeReason
                          "
                        ></button>
                      }
                      @if (customTree(); as tree) {
                        <span class="font-medium text-green-500">
                          {{ matchLabel(tree.confidence) }}
                        </span>
                      }
                    </div>
                    <ul
                      class="m-0 list-none space-y-1 pl-0 text-sm"
                      aria-label="AI-suggested draft structure"
                    >
                      @for (row of customTreeRows(); track $index) {
                        <li
                          class="flex flex-wrap items-baseline gap-x-2 gap-y-0.5"
                          [style.padding-left.rem]="row.depth * 0.75"
                        >
                          <span class="font-medium">
                            {{ row.name }} ×{{ row.quantity }}
                          </span>
                          @if (row.materialLabel) {
                            <span class="text-muted-color">
                              Material · {{ row.materialLabel }}
                            </span>
                          }
                          @if (row.pricingLabel) {
                            <span class="text-muted-color">
                              Pricing · {{ row.pricingLabel }}
                            </span>
                          }
                        </li>
                      }
                    </ul>
                  </div>
                }
              </div>

              @if (suggestionAdvice().length) {
                <div class="min-w-0 flex flex-col gap-2">
                  <div class="text-sm font-medium">
                    Issues and advice · {{ suggestionAdvice().length }}
                  </div>
                  @for (item of suggestionAdvice(); track $index) {
                    <div
                      class="flex items-start gap-2 rounded-md px-3 py-2 text-sm text-surface-switch-900"
                      [class.bg-orange-400/15]="item.type === 'warning'"
                      [class.bg-sky-400/15]="item.type === 'advice'"
                    >
                      <i
                        [class]="
                          'mt-0.5 shrink-0 pi ' +
                          (item.type === 'warning'
                            ? 'pi-exclamation-triangle text-orange-400'
                            : 'pi-info-circle text-sky-400')
                        "
                        aria-hidden="true"
                      ></i>
                      <span>{{ item.text }}</span>
                    </div>
                  }
                </div>
              }
            </div>
          }

          <div class="flex items-start gap-4">
            <div class="h-[60vh] min-h-[20rem] w-[45%] min-w-0">
              <app-pdf-viewer
                [fileUrl]="activeDrawingFile()?.file_url ?? null"
              />
            </div>
            <div class="w-[55%] min-w-0">
              @if (isExistingDrawing(activeDrawingFile())) {
                <p-message severity="info" styleClass="w-full mb-4">
                  This existing drawing's extracted information cannot be
                  changed here. Upload a new drawing file to review and change
                  it.
                </p-message>
              }
              <fieldset
                [disabled]="isExistingDrawing(activeDrawingFile())"
                class="border-0 p-0 m-0"
              >
                <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <div class="flex flex-col gap-1">
                    <label
                      class="text-sm font-medium flex items-center gap-1"
                      for="drawing-part-number"
                    >
                      Part Number
                      <app-low-confidence-icon
                        [show]="isLowConfidence('part_number')"
                      />
                    </label>
                    <input
                      id="drawing-part-number"
                      pInputText
                      class="w-full"
                      [class.border-orange-400]="isLowConfidence('part_number')"
                      [ngModel]="editForm().part_number"
                      (ngModelChange)="updateField('part_number', $event)"
                    />
                  </div>

                  <div class="flex flex-col gap-1">
                    <label
                      class="text-sm font-medium flex items-center gap-1"
                      for="drawing-title"
                    >
                      Title
                      <app-low-confidence-icon
                        [show]="isLowConfidence('title')"
                      />
                    </label>
                    <input
                      id="drawing-title"
                      pInputText
                      class="w-full"
                      [class.border-orange-400]="isLowConfidence('title')"
                      [ngModel]="editForm().title"
                      (ngModelChange)="updateField('title', $event)"
                    />
                  </div>

                  <div class="flex flex-col gap-1">
                    <label
                      class="text-sm font-medium flex items-center gap-1"
                      for="drawing-revision"
                    >
                      Revision
                      <app-low-confidence-icon
                        [show]="isLowConfidence('revision')"
                      />
                    </label>
                    <input
                      id="drawing-revision"
                      pInputText
                      class="w-full"
                      [class.border-orange-400]="isLowConfidence('revision')"
                      [ngModel]="editForm().revision"
                      (ngModelChange)="updateField('revision', $event)"
                    />
                  </div>

                  <div class="flex flex-col gap-1">
                    <label
                      class="text-sm font-medium flex items-center gap-1"
                      for="drawing-material"
                    >
                      Material
                      <app-low-confidence-icon
                        [show]="isLowConfidence('material')"
                      />
                    </label>
                    <input
                      id="drawing-material"
                      pInputText
                      class="w-full"
                      [class.border-orange-400]="isLowConfidence('material')"
                      [ngModel]="editForm().material"
                      (ngModelChange)="updateField('material', $event)"
                    />
                  </div>

                  <div class="flex flex-col gap-1">
                    <label
                      class="text-sm font-medium flex items-center gap-1"
                      for="drawing-units"
                    >
                      Units <span class="text-red-500">*</span>
                      <app-low-confidence-icon
                        [show]="isLowConfidence('units')"
                      />
                    </label>
                    <input
                      id="drawing-units"
                      pInputText
                      class="w-full"
                      [class.border-orange-400]="isLowConfidence('units')"
                      [ngModel]="editForm().units"
                      (ngModelChange)="updateField('units', $event)"
                    />
                  </div>

                  <div class="flex flex-col gap-1">
                    <label
                      class="text-sm font-medium flex items-center gap-1"
                      for="drawing-length"
                    >
                      Length <span class="text-red-500">*</span>
                      <app-low-confidence-icon
                        [show]="isLowConfidence('dimensions')"
                      />
                    </label>
                    <input
                      id="drawing-length"
                      pInputText
                      class="w-full"
                      [class.border-orange-400]="isLowConfidence('dimensions')"
                      [ngModel]="editForm().length"
                      (ngModelChange)="updateField('length', $event)"
                    />
                  </div>

                  <div class="flex flex-col gap-1">
                    <label
                      class="text-sm font-medium flex items-center gap-1"
                      for="drawing-width"
                    >
                      Width <span class="text-red-500">*</span>
                      <app-low-confidence-icon
                        [show]="isLowConfidence('dimensions')"
                      />
                    </label>
                    <input
                      id="drawing-width"
                      pInputText
                      class="w-full"
                      [class.border-orange-400]="isLowConfidence('dimensions')"
                      [ngModel]="editForm().width"
                      (ngModelChange)="updateField('width', $event)"
                    />
                  </div>

                  <div class="flex flex-col gap-1">
                    <label
                      class="text-sm font-medium flex items-center gap-1"
                      for="drawing-depth"
                    >
                      Depth <span class="text-red-500">*</span>
                      <app-low-confidence-icon
                        [show]="isLowConfidence('dimensions')"
                      />
                    </label>
                    <input
                      id="drawing-depth"
                      pInputText
                      class="w-full"
                      [class.border-orange-400]="isLowConfidence('dimensions')"
                      [ngModel]="editForm().depth"
                      (ngModelChange)="updateField('depth', $event)"
                    />
                  </div>

                  <div class="flex flex-col gap-1">
                    <label
                      class="text-sm font-medium"
                      for="drawing-profile-edge-length"
                    >
                      Profile edge length (mm)
                    </label>
                    <input
                      id="drawing-profile-edge-length"
                      pInputText
                      class="w-full"
                      [ngModel]="editForm().profile_edge_length"
                      (ngModelChange)="
                        updateField('profile_edge_length', $event)
                      "
                    />
                    <p class="text-xs text-muted-color">
                      Combined outer contour and non-hole cut-out contour
                      length.
                    </p>
                  </div>

                  <div class="flex flex-col gap-1">
                    <label
                      class="text-sm font-medium"
                      for="drawing-hole-edge-length"
                    >
                      Hole edge length (mm)
                    </label>
                    <input
                      id="drawing-hole-edge-length"
                      pInputText
                      class="w-full"
                      [ngModel]="editForm().hole_edge_length"
                      (ngModelChange)="updateField('hole_edge_length', $event)"
                    />
                    <p class="text-xs text-muted-color">
                      Total contour length of the holes.
                    </p>
                  </div>

                  <p class="text-sm text-muted-color md:col-span-2">
                    {{ trimEdgeLengthHelp }}
                  </p>

                  <div class="flex flex-col gap-1">
                    <label
                      class="text-sm font-medium flex items-center gap-1"
                      for="drawing-holes"
                    >
                      Holes
                      <app-low-confidence-icon
                        [show]="isLowConfidence('holes')"
                      />
                    </label>
                    <input
                      id="drawing-holes"
                      pInputText
                      class="w-full"
                      [class.border-orange-400]="isLowConfidence('holes')"
                      [ngModel]="editForm().holes"
                      (ngModelChange)="updateField('holes', $event)"
                    />
                  </div>

                  <div class="flex flex-col gap-1">
                    <label
                      class="text-sm font-medium flex items-center gap-1"
                      for="drawing-complexity"
                    >
                      Complexity
                      @if (complexityReason()) {
                        <button
                          type="button"
                          class="pi pi-info-circle text-sm text-muted-color cursor-pointer bg-transparent border-0 p-0 leading-none"
                          [pTooltip]="complexityReason()"
                          tooltipPosition="top"
                          tooltipEvent="both"
                          [attr.aria-label]="
                            'Complexity reasoning: ' + complexityReason()
                          "
                          (click)="$event.preventDefault()"
                        ></button>
                      }
                      <app-low-confidence-icon
                        [show]="isLowConfidence('complexity_confidence')"
                      />
                    </label>
                    <p-select
                      inputId="drawing-complexity"
                      class="w-full"
                      [options]="complexityOptions"
                      optionLabel="label"
                      optionValue="value"
                      placeholder="Select complexity"
                      [showClear]="true"
                      [disabled]="isExistingDrawing(activeDrawingFile())"
                      [ngModel]="editForm().complexity || null"
                      (ngModelChange)="
                        updateField('complexity', $event ?? 'standard')
                      "
                    />
                  </div>

                  <div class="flex flex-col gap-1 md:col-span-2">
                    <label
                      class="text-sm font-medium flex items-center gap-1"
                      for="drawing-tolerances"
                    >
                      Tolerances
                      <app-low-confidence-icon
                        [show]="isLowConfidence('tolerances')"
                      />
                    </label>
                    <textarea
                      id="drawing-tolerances"
                      pTextarea
                      rows="3"
                      class="w-full"
                      [class.border-orange-400]="isLowConfidence('tolerances')"
                      [ngModel]="editForm().tolerances"
                      (ngModelChange)="updateField('tolerances', $event)"
                    ></textarea>
                  </div>

                  <div class="flex flex-col gap-1 md:col-span-2">
                    <label
                      class="text-sm font-medium flex items-center gap-1"
                      for="drawing-notes"
                    >
                      General Notes
                      <app-low-confidence-icon
                        [show]="isLowConfidence('general_notes')"
                      />
                    </label>
                    <textarea
                      id="drawing-notes"
                      pTextarea
                      rows="4"
                      class="w-full"
                      [class.border-orange-400]="
                        isLowConfidence('general_notes')
                      "
                      [ngModel]="editForm().general_notes"
                      (ngModelChange)="updateField('general_notes', $event)"
                    ></textarea>
                  </div>
                </div>

                <div class="mt-6">
                  <div class="flex items-center justify-between mb-2">
                    <label class="text-sm font-medium">Dimensions</label>
                    <p-button
                      label="Add dimension"
                      icon="pi pi-plus"
                      size="small"
                      severity="secondary"
                      (onClick)="addDimensionRow()"
                    />
                  </div>

                  @if (editForm().dimensions.length === 0) {
                    <p class="text-sm text-muted-color">
                      No dimensions extracted.
                    </p>
                  } @else {
                    <div class="flex flex-col gap-2">
                      @for (
                        dim of editForm().dimensions;
                        track $index;
                        let i = $index
                      ) {
                        <div class="flex gap-2 items-center">
                          <input
                            pInputText
                            class="flex-1"
                            placeholder="Name"
                            [ngModel]="dim.key"
                            (ngModelChange)="updateDimensionKey(i, $event)"
                          />
                          <input
                            pInputText
                            class="flex-1"
                            placeholder="Value"
                            [ngModel]="dim.value"
                            (ngModelChange)="updateDimensionValue(i, $event)"
                          />
                          <p-button
                            icon="pi pi-times"
                            [text]="true"
                            [rounded]="true"
                            severity="danger"
                            (onClick)="removeDimensionRow(i)"
                          />
                        </div>
                      }
                    </div>
                  }
                </div>
              </fieldset>
            </div>
          </div>
        </div>
      </div>

      <div
        class="shrink-0 flex flex-col gap-2 border-t border-surface-switch-200 pt-4"
      >
        @if (confirmError()) {
          <p-message severity="error" styleClass="w-full">
            {{ confirmError() }}
          </p-message>
        }
        <div class="flex justify-end gap-2">
          <p-button
            label="Cancel"
            severity="secondary"
            [text]="true"
            (onClick)="onDialogHide()"
          />
          <p-button
            [label]="confirmButtonLabel"
            icon="pi pi-check"
            [loading]="confirming()"
            [disabled]="!canConfirm()"
            (onClick)="onConfirmDrawing()"
          />
        </div>
      </div>
    }
  </div>
</p-dialog>

<shared-confirm-dialog />
